var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_vm._l((_vm.aboutData),function(page){return [_c('AboutContent',{key:page.id,attrs:{"pageData":page}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }